export function RouteTotalDriverPays(shipments) {
  let totalRoutePay = 0;
  (Array.isArray(shipments) ? shipments : []).forEach(shipment => {
    // Once a driver is assigned, use the actual DriverPay total_earning (includes bonus
    // and any pay adjustments); fall back to the quote-time estimate before assignment.
    const pays = shipment && Array.isArray(shipment.DriverPays)
      ? shipment.DriverPays.filter(pay => pay && !pay.deleted_at)
      : [];
    if (pays.length > 0) {
      pays.forEach(pay => {
        totalRoutePay += Number(pay.total_earning) || 0;
      });
      return;
    }

    const blob = shipment && shipment.shipping_fee_blob;
    const driverEarning = blob && blob.driverEarning;
    if (!driverEarning) {
      return;
    }

    const driver1099 = Number(driverEarning.driver_1099_earning) || 0;
    const passenger1099 = Number(driverEarning.passenger_1099_earning) || 0;
    const numOfGophrs = Math.max((Number(shipment && shipment.num_of_gophrs) || 1) - 1, 0);
    totalRoutePay += driver1099 + passenger1099 * numOfGophrs;
  });
  return totalRoutePay.toFixed(2);
}
